// The product's name in billing copy (the checkout window, receipts and
// plan pages). One build-time setting, so a rebrand never touches billing
// code - the backend reads its own PRODUCT_NAME for emails and the pricing
// catalogue.
export const PRODUCT_NAME = (process.env.REACT_APP_PRODUCT_NAME || '').trim() || 'KrishvaQ';
